import STRINGS from './strings'

const farmerHelplineAssetDir = '/assets/images/farmer-helpline'

const appList = [
  {
    icon: '/assets/images/farmer',
    alt: STRINGS.COMMON.DEHAAT_FARMER_APP,
    appName: STRINGS.COMMON.DEHAAT_FARMER_APP,
    appLink:
      'https://play.google.com/store/apps/details?id=app.intspvt.com.farmer',
  },
  {
    icon: '/assets/images/business-app',
    alt: STRINGS.COMMON.DEHAAT_BUSINESS_APP,
    appName: STRINGS.COMMON.DEHAAT_BUSINESS_APP,
    appLink:
      'https://play.google.com/store/apps/details?id=com.intspvt.app.dehaat2',
  },
]

const helplineAreas = [
  {
    label: STRINGS.FARMER_HELPLINE.CROP_PLANNING_GROWTH,
    imageUrl: `${farmerHelplineAssetDir}/plant`,
  },
  {
    label: STRINGS.FARMER_HELPLINE.DISEASE_DETECTION,
    imageUrl: `${farmerHelplineAssetDir}/germs`,
  },
  {
    label: STRINGS.FARMER_HELPLINE.PESTICIDE_DOSAGE,
    imageUrl: `${farmerHelplineAssetDir}/chamber`,
  },
  {
    label: STRINGS.FARMER_HELPLINE.BEST_HARVESTING_PRACTICES,
    imageUrl: `${farmerHelplineAssetDir}/harvester`,
  },
]

const sliderImageList = [
  {
    id: 1,
    image: `${farmerHelplineAssetDir}/team1`,
    alt: 'DeHaat Advisory Team 1',
  },
  {
    id: 2,
    image: `${farmerHelplineAssetDir}/team2`,
    alt: 'DeHaat Advisory Team 2',
  },
  {
    id: 3,
    image: `${farmerHelplineAssetDir}/team3`,
    alt: 'DeHaat Advisory Team 3',
  },
  {
    id: 4,
    image: `${farmerHelplineAssetDir}/team4`,
    alt: 'DeHaat Advisory Team 4',
  },
]

export { appList, helplineAreas, sliderImageList }
